import i18n from "@/i18n";

const routes = {
  path: "/tournament",
  name: "Tournament",
  component: () =>
    import(/* webpackChunkName: "tournament" */ "@/views/tournament/Main"),
  children: [
    {
      path: "tournamentlist",
      alias: "",
      name: "TournamentList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentList"
        ),
      prop: true,
      meta: {
        location: "/tournament/tournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.admin_tournament"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 41,
      },
    },
    {
      path: "tournamentview/:tournamentno+",
      name: "TournamentView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentView"
        ),
      prop: true,
      meta: {
        location: "/tournament/tournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_info"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 41,
      },
    },
    {
      path: "tournamentwrite",
      name: "TournamentWrite",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentWrite"
        ),
      prop: true,
      meta: {
        location: "/tournament/tournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_write"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 41,
      },
    },
    {
      path: "tournamentwrite/:tournamentno+",
      name: "TournamentModify",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentWrite"
        ),
      prop: true,
      meta: {
        location: "/tournament/tournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_edit"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 41,
      },
    },

    {
      path: "tournamentrank/:tournamentno",
      name: "TournamentRank",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentRank"
        ),
      prop: true,
      meta: {
        location: "/tournament/tournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_rank"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 41,
      },
    },
    {
      path: "tournamentlocations/:tournamentno+",
      name: "TournamentLocations",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentLocations"
        ),
      prop: true,
      meta: {
        location: "/tournament/tournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_location"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 41,
      },
    },

    {
      path: "shoptournamentlist",
      alias: "",
      name: "ShopTournamentList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopTournamentList"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoptournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.shop_tournament"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 42,
      },
    },
    {
      path: "shoptournamentwrite",
      name: "ShopTournamentWrite",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopTournamentWrite"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoptournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_write"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 42,
      },
    },
    {
      path: "shoptournamentwrite/:tournamentno+",
      name: "ShopTournamentModify",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopTournamentWrite"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoptournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_edit"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 42,
      },
    },

    {
      path: "shoptournamentrank/:tournamentno",
      name: "ShopTournamentRank",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopTournamentRank"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoptournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_rank"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 42,
      },
    },
    {
      path: "shoptournamentview/:tournamentno",
      name: "ShopTournamentView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopTournamentView"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoptournamentlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_info"),
        step: [
          i18n.t("page.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 4,
        sub_menu_num: 42,
      },
    },
  ],
};

export default routes;
